import React from "react";

export default function ForgotPassword() {
  let submit = (e) => {
    e.preventDefault();
  };
  return (
    <div className="flex justify-center gap-3 flex-col">
      <h1 className="text-center text-white font-bold text-3xl">
        Forgot Password
      </h1>
      <form action="">
        <span className="flex flex-col gap-2">
          <label htmlFor="email" className="text-white">
            Email
          </label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            id=""
            className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6"
          />
        </span>
        <button
          onClick={submit}
          className="mt-9 lg:w-fit lg:h-[64px] rounded-full bg-[#01FF00] text-black px-6 py-3 font-bold text-xl"
        >
          Rest password
        </button>
      </form>
    </div>
  );
}
